import PropTypes from 'prop-types'
import React from 'react'
import { NavLink } from 'react-router-dom'
import styled from 'styled-components'

const StyledComponent = styled(({css, ...rest}) => <NavLink {...rest} />)`
    display: inline-block;
    font-size: 7px;
    font-weight: 400;
    line-height: 12px;
    margin-top: 2px;
    white-space: nowrap;

    @media (min-width: ${p => p.theme.mobileSize}) {
      font-size: 8px;
      margin-top: 0;
    }

    @media (min-width: ${p => p.theme.mobileLargeSize}) {
      font-size: 15px;
      line-height: 20px;
    }

  ${p => p.css};
`

const _PageHeader_Logo_SportType = (props) => <StyledComponent {...props} />
_PageHeader_Logo_SportType.propTypes = {
  css: PropTypes.string,
}

export default _PageHeader_Logo_SportType
